// extracted by mini-css-extract-plugin
module.exports = {"form":"change-email_form__yJ5dp","actions":"change-email_actions__Zn991"};